//#region ------------ function shorthand -------------------------
var getByID = (element)=>{return document.getElementById(element)}
var getByClass = (element)=>{return document.querySelector('.'+element)}
var getByClassAll = (element)=>{return document.querySelectorAll('.'+element)}
//#endregion ----------------------

if(getByID('faq_box')){

    var faqAll = getByID('faq_box');
    var listFaq = faqAll.querySelectorAll('.list-faq');
    var faqArray = '{"faq":[';
    var MainLength = listFaq.length;
    listFaq.forEach((listFaq,key) => {
        let topicFaq = listFaq.querySelector('.topic-faq');
        let toggleFaq = topicFaq.querySelector('.toggle-faq');
        let topicFaqTitle = topicFaq.querySelector('.topic-faq-title');
        let topicData = topicFaqTitle.getAttribute('data-faq');
        let mainID = topicFaqTitle.getAttribute('main-id');
        // console.log(topicFaqTitle.getAttribute('data-faq'));
        faqArray += '{"faq_topic":"'+topicData+'",';
        faqArray += '"faq_topic_id":"'+mainID+'","sub_faq":[';
        let listsubfaq = listFaq.querySelector('.list-subfaq');
        let subfaq = listsubfaq.querySelectorAll('.subfaq');
        topicFaq.addEventListener('click',()=>{
            let status = listsubfaq.getAttribute('status');
            if (status == 'opened') {
                listsubfaq.classList.add('closed');
                listsubfaq.setAttribute('status','closed');
                toggleFaq.classList.remove('fa-rotate-180');
            } else {
                listsubfaq.classList.remove('closed');
                listsubfaq.setAttribute('status','opened');
                toggleFaq.classList.add('fa-rotate-180');
            }
        });
        var subLength = subfaq.length;
        subfaq.forEach((subfaq,index) => {
            let titlefaq = subfaq.querySelector('.title-faq');
            let togglesubfaq = titlefaq.querySelector('.toggle-subfaq');
            let question = titlefaq.querySelector('.title-faq-question');
            // console.log(question.getAttribute('data-faq'));
            let subfaqContent = subfaq.querySelector('.sub-faq-content')
            let mainIDsub = question.getAttribute('main-id');
            // console.log(subfaqContent.getAttribute('data-faq'));
            faqArray += '{"sub_faq_question":"'+question.getAttribute('data-faq')+'",';
            faqArray += '"sub_faq_answer":"'+subfaqContent.getAttribute('data-faq')+'",';
            faqArray += '"main_id":"'+mainIDsub+'"}';
            if (index+1 != subLength) {
                faqArray += ',';
            }
            titlefaq.addEventListener('click',()=>{
                let status = subfaqContent.getAttribute('status');
                if (status == 'opened') {
                    subfaqContent.classList.add('closed');
                    subfaqContent.setAttribute('status','closed');
                    togglesubfaq.classList.remove('fa-rotate-180');
                } else {
                    subfaqContent.classList.remove('closed');
                    subfaqContent.setAttribute('status','opened');
                    togglesubfaq.classList.add('fa-rotate-180');
                }
            });
        });
        faqArray += "]}";
        if (key+1 != MainLength) {
            faqArray += ',';
        }
    });
    faqArray += "]}";
    var faqJSON=JSON.parse(faqArray);
    // console.log(faqJSON)
    resultSearch = () =>{
        let faq_all= faqJSON; 
        let faqBox = getByID('faq_box');
        var listFaq = faqBox.querySelectorAll('.list-faq');
        listFaq.forEach(listFaq => {
            listFaq.classList.add('d-none');
        });
        // faqBox.innerHTML="";
        let searchValue = getByID('faq-search');
        Object.keys(faq_all).forEach(function(key) {
            var value = faq_all[key];
        
            Object.keys(value).forEach(function(key) {
                var faq = value[key];
                var sub_faq = faq.sub_faq;
                var subfaqContent = "";
                Object.keys(sub_faq).forEach(function(key) {
                    subfaqContent = sub_faq[key];                        
                })
                if(subfaqContent.sub_faq_answer.toLowerCase().indexOf(searchValue.value.toLowerCase()) > -1){
                    // console.log(subfaqContent.sub_faq_answer);
                    getByID(subfaqContent.main_id).classList.remove('d-none');
                    // Object.keys(sub_faq).forEach(function(key) {
                    //     subfaqContent = sub_faq[key];
                    // })
                }else{
                    if(subfaqContent.sub_faq_question.toLowerCase().indexOf(searchValue.value.toLowerCase()) > -1){
                        // console.log(subfaqContent.sub_faq_question);
                        getByID(subfaqContent.main_id).classList.remove('d-none');
                        // Object.keys(sub_faq).forEach(function(key) {
                        //     subfaqContent = sub_faq[key];
                        // })
                    }else{
                        if(faq.faq_topic.toLowerCase().indexOf(searchValue.value.toLowerCase()) > -1){
                            // console.log(faq.faq_topic);
                            getByID(faq.faq_topic_id).classList.remove('d-none');
                            // Object.keys(sub_faq).forEach(function(key) {
                            //     subfaqContent = sub_faq[key];
                            // })
                        }
                    }
                }
            })
        
        });
    }

    
    getByClass('btn-search-faq').addEventListener('click',resultSearch);
    getByID('faq-search').addEventListener('keydown',(e)=>{
        if(e.keyCode == 13){
            resultSearch()
        }
    });
}